import customSelect from 'custom-select';
import 'custom-select/build/custom-select.css';

const initCustomSelect = (select) => {
  let customselect = $(select);
  customselect.each(function (index, el) { new customSelect(el) });
};

export { initCustomSelect }
